import { ButtonProps } from '../../atoms/Button';
import { DividerProps } from '../../atoms/Divider';
import { FooterProps } from '../../organisms/Footer';
import { TopNavProps } from '../../organisms/TopNav';
import { HomepageProps } from '../../pages/Homepage';


type MainLayoutInternalProps = {
  topNav?: TopNavProps;
  homepage?: HomepageProps;
  divider?: DividerProps;
  footer?: FooterProps;
  skipToMainContentButton?: ButtonProps; // MANUAL OVERRIDE
};

type MainLayoutPropsValues = {
  '': MainLayoutInternalProps;
};

const propValues: MainLayoutPropsValues = {
  '': {
    topNav: {
      type: 'WithoutSearchInNav',
    },
    homepage: {
    },
    divider: {
      type: 'Horizontal',
      style: 'Thin',
      colour: 'DigitalGrey15',
    },
    footer: {
      style: 'Default',
    },
    // MANUAL OVERRIDE STARTS
    skipToMainContentButton: {
      size: 'Large',
      style: 'ContainedWhite',
      type: 'Text',
    },
    // MANUAL OVERRIDE ENDS
  },
};

const getProps = (type: string): MainLayoutInternalProps => {
  const values: MainLayoutInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
